import {useEffect, useRef} from "react";
import './QueuePanel.scss'

type Props = {
    queue: VideoFile[]
    currentIndex: number
    onJump: (file: VideoFile, index: number) => void
    onShuffle: () => void
    onClear: () => void
}

export default ({ queue, currentIndex, onJump, onShuffle, onClear }: Props) => {
    const listRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (!listRef.current) return
        const active = listRef.current.querySelector<HTMLElement>('.qp-item--current')
        active?.scrollIntoView({ block: 'nearest' })
    }, [currentIndex])

    return (
        <div className="queue-panel">
            <div className="qp-toolbar">
                <span className="qp-count">{queue.length} in queue</span>
                <button className="qp-btn" onClick={onShuffle} title="Shuffle remaining">⇌</button>
                <button className="qp-btn qp-btn--clear" onClick={onClear} title="Clear queue">✕ Clear</button>
            </div>
            <div className="qp-list" ref={listRef}>
                {queue.map((file, i) => {
                    const isPast    = i < currentIndex
                    const isCurrent = i === currentIndex
                    return (
                        <div
                            key={file.hash + i}
                            className={
                                'qp-item' +
                                (isCurrent ? ' qp-item--current' : '') +
                                (isPast    ? ' qp-item--past'    : '')
                            }
                            onClick={() => onJump(file, i)}
                        >
                            <span className="qp-idx">{i + 1}</span>
                            <img className="qp-thumb" src={file.paths.thumbnail} alt="" loading="lazy"/>
                            <div className="qp-info">
                                <span className="qp-name">{file.name}</span>
                                <span className="qp-dir">{file.directory?.name}</span>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
